import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { Heart } from "./Heart";
import { Animation, Group, Parent } from "./styles";
import { HEARTS_ANIMATION, HEARTS_ANIMATION_GROUP } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeartsAnimation = function HeartsAnimation(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    shouldAnimationRun = _ref.shouldAnimationRun,
    state = _ref.state;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    hearts = _useState2[0],
    setHearts = _useState2[1];
  useEffect(function () {
    if (!state || !shouldAnimationRun) {
      return undefined;
    }
    var angle = Math.random() * Math.PI * 2;
    var heartsGroup = {
      angle: angle,
      id: v4(),
      length: 3
    };
    window.requestAnimationFrame(function () {
      setHearts(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [heartsGroup]);
      });
    });
    var timeout = setTimeout(function () {
      window.requestAnimationFrame(function () {
        setHearts(function () {
          return [];
        });
      });
    }, 1500);
    return function () {
      clearTimeout(timeout);
    };
  }, [state, shouldAnimationRun]);
  return /*#__PURE__*/_jsxs(Animation, {
    "data-testid": HEARTS_ANIMATION,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(Parent, {
      children: children
    }), hearts.map(function (group) {
      return /*#__PURE__*/_jsx(Group, {
        "data-testid": HEARTS_ANIMATION_GROUP,
        children: Array.from({
          length: group.length
        }, function (value, index) {
          return /*#__PURE__*/_jsx(Heart, {
            angle: group.angle,
            index: index
          }, index);
        })
      }, group.id);
    })]
  });
};
//# sourceMappingURL=HeartsAnimation.js.map